import type { RouterClient } from '@orpc/server';
import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import type { WorkerRouter } from './router-worker';

const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    // Always use the same origin - the worker serves both frontend and API
    return `${window.location.origin}/rpc`;
  }
  return 'http://localhost:8787/rpc';
};

const link = new RPCLink({
  url: getBaseUrl(),
});

export const orpc: RouterClient<WorkerRouter> = createORPCClient(link);
